import { gql } from "graphql-tag"

export default gql`
  type Country {
    createdAt: String!
    currencyId: ID
    displayName: String!
    flagEmoji: String!
    flagImageId: ID!
    id: ID!
    isPublished: Boolean!
    iso2: String!
    iso3: String!
    name: String!
    numeric: Int!
    publishedAt: String
    region: String!
    timezones: [String!]!
    updatedAt: String!
  }

  input CountryAddInput {
    currencyId: ID
    displayName: String!
    flagEmoji: String!
    flagImageId: ID!
    isPublished: Boolean!
    iso2: String!
    iso3: String!
    name: String!
    numeric: Int!
    publishedAt: String
    region: String!
    timezones: [String!]!
  }

  input CountryUpdateInput {
    currencyId: ID
    displayName: String
    flagEmoji: String
    flagImageId: ID
    isPublished: Boolean
    iso2: String
    iso3: String
    name: String
    numeric: Int
    publishedAt: String
    region: String
    timezones: [String!]
  }

  type CountriesWave {
    cursor: String
    countries: [Country]!
    hasPrevData: Boolean
    hasNextData: Boolean!
    prevCursor: String
  }

  input GetQueryCountries {
    createdAt: String
    isAscending: Boolean
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input GetWaveQueryCountries {
    createdAt: String
    cursor: String
    isPublished: Boolean
    limit: Int
    sortBy: String
  }
`
